import apiUtils from '@elab/core/utils/apiUtils';

import HTTPClient from '../../utils/HTTPClient';
import cartApi from '../cart/api';

import { defaultApiSearchParams } from './config';

const getApiService = () => `${apiUtils.getBaseUri()}/stores`;

const createStoresSearchParams = (params = {}) => {
    params.fields = params.fields || defaultApiSearchParams.FIELDS;
    const searchParams = new URLSearchParams();

    Object.keys(params).forEach(key => params[key] && searchParams.append(key, params[key]));
    return searchParams.toString();
};

const getStores = async data => {
    const uri = `${getApiService()}?${createStoresSearchParams(data)}`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load stores (${response.status})`);
    }

    return await response.json();
};

const getStoresByTown = async town => {
    const uri = `${getApiService()}/town/${town}`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load stores (${response.status})`);
    }
    return await response.json();
};

const getPostOfficesByPostalCode = async data => {
    const uri = `${apiUtils.getBaseUri()}/postoffice?${createStoresSearchParams(data)}`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load stores (${response.status})`);
    }
    return await response.json();
};

const createSuggestedStoresSearchParams = radius => {
    const searchParams = new URLSearchParams();
    searchParams.append('radius', radius);
    searchParams.append('accuracy', defaultApiSearchParams.ACCURACY);
    searchParams.append('currentPage', defaultApiSearchParams.CURRENT_PAGE);
    searchParams.append('pageSize', defaultApiSearchParams.PAGE_SIZE);
    searchParams.append('fields', defaultApiSearchParams.FIELDS);

    return searchParams.toString();
};

const getSuggestedStores = async ({ userId, cartId, radius }) => {
    const uri = `${cartApi.getCurrentCartApiService(
        userId,
        cartId,
    )}/suggestedstores?${createSuggestedStoresSearchParams(radius)}`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load stores (${response.status})`);
    }
    return await response.json();
};

export default {
    getStores,
    getSuggestedStores,
    getStoresByTown,
    getPostOfficesByPostalCode,
};
